  document.addEventListener("DOMContentLoaded", function () {
    const accordions = document.querySelectorAll('.product__accordion, .accordion');
    accordions.forEach(function (acc) {
      const content = acc.querySelector('.accordion__content, .details-content');
      if (content && content.innerHTML.trim() === "") {
        acc.style.display = 'none';
        console.log("hidden acc");
      }
      if (content && content.innerHTML.includes('Select a page to display its content')) {
        acc.style.display = 'none';
        console.log("hidden acc");
      }
      else {console.log("show acc", content.innerHTML);}
    });
  });

  